export default "__VITE_ASSET__BXDLd5cQ__"